/** @format */

import { Typography } from '@mui/material';
import _ from 'lodash';
import { Fragment, useEffect, useState } from 'react';
import {
  ResourceType,
  useInstitutionalResources,
} from '../../hooks/useInstitutionalResources';
import VegaSearchBy from '../common/VegaSearchBy';
import VegaTable from '../common/VegaTable';
import { VegaCard } from '../common';

function PincodeTable() {
  const { loading, fetchResource } = useInstitutionalResources();
  const [countryCodes, setCountryCodes] = useState<any[]>([]);
  const [page, setPage] = useState<number>(0);
  const [pageSize, setPageSize] = useState<number>(10);
  const [rowCount, setRowCount] = useState<number>(0);
  const [filter, setFilter] = useState<{ search: string; searchBy: string }>({
    search: '',
    searchBy: PINCODE_COLUMNS[0].value,
  });

  async function fetchPincodes() {
    try {
      const response = await fetchResource<any>({
        type: ResourceType.PINCODE,
        page: page,
        pageSize: pageSize,
        searchBy: filter.searchBy,
        searchQuery: filter.search,
      });
      setCountryCodes(response.records);
      setRowCount(response.totalItems);
    } catch (error) {}
  }

  const onFilterChange = (name: string, value: string) => {
    if (name === 'searchBy') {
      setFilter((preVal: any) => ({
        ...preVal,
        ['search']: '',
        ['searchBy']: value,
      }));
    } else {
      setFilter((preVal: any) => ({
        ...preVal,
        [name]: value,
      }));
    }
  };

  useEffect(() => {
    fetchPincodes();
  }, [page, pageSize, filter.search, filter.searchBy]);

  return (
    <Fragment>
      <VegaSearchBy
        placeholder="Search"
        data={PINCODE_COLUMNS}
        searchByname="searchBy"
        searchName="search"
        key="search"
        state={filter}
        handleChange={onFilterChange}
      />
      <VegaCard noPad>
        <VegaTable
          data={countryCodes}
          columnDef={columnPinCode}
          idColumn={'id'}
          onPageChange={setPage}
          onPageSizeChange={setPageSize}
          page={page}
          pageSize={pageSize}
          rowCount={rowCount}
          paginationMode="server"
          loading={loading}
        />
      </VegaCard>
    </Fragment>
  );
}
export default PincodeTable;

const PINCODE_COLUMNS = [
  {
    text: 'City',
    value: 'city',
  },
  {
    text: 'State',
    value: 'state',
  },
  {
    text: 'Country',
    value: 'country',
  },
  {
    text: 'Pincode',
    value: 'pincode',
  },
];

const columnPinCode = [
  {
    field: 'pincode',
    headerName: '  Pin Code',

    flex: 1,
  },
  {
    field: 'city',
    headerName: '  City',
    renderCell: (props: any) => {
      return <Typography>{_.capitalize(props.row.city)}</Typography>;
    },
    flex: 1,
  },
  {
    field: 'state',
    headerName: '  State',
    renderCell: (props: any) => {
      return <Typography>{_.capitalize(props.row.state)}</Typography>;
    },
    flex: 1,
  },
  {
    field: 'country',
    headerName: '  Country',

    flex: 1,
  },
];
